export default __webpack_public_path__ + "static/media/dominic.48e19581.jpeg";